/**
 * Define additional input action types here
 * Give an enum name, followed by a string value
 */
export var InputAction;
(function (InputAction) {
    InputAction["MOVE_UP"] = "MOVE_UP";
    InputAction["MOVE_DOWN"] = "MOVE_DOWN";
    InputAction["MOVE_LEFT"] = "MOVE_LEFT";
    InputAction["MOVE_RIGHT"] = "MOVE_RIGHT";
    InputAction["PICK_UP"] = "PICK_UP";
    InputAction["DROP"] = "DROP";
    InputAction["FULFILL"] = "FULFILL";
    InputAction["JUMP"] = "JUMP";
    InputAction["SPRINT"] = "SPRINT";
    InputAction["ATTACK"] = "ATTACK";
    InputAction["INVENTORY1"] = "INVENTORY1";
    InputAction["INVENTORY2"] = "INVENTORY2";
    InputAction["INVENTORY3"] = "INVENTORY3";
    InputAction["INVENTORY4"] = "INVENTORY4";
    InputAction["INVENTORY5"] = "INVENTORY5";
    InputAction["INVENTORY6"] = "INVENTORY6";
    InputAction["INVENTORY7"] = "INVENTORY7";
    InputAction["INVENTORY8"] = "INVENTORY8";
    InputAction["INVENTORY9"] = "INVENTORY9";
    InputAction["PAUSE"] = "PAUSE";
})(InputAction || (InputAction = {}));
